import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { LeadsCriteria } from '../models/leads-criteria.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LeadsCriteriaService {
  private apiBaseUrl = environment.apiBaseUrl;
  private http: HttpClient = inject(HttpClient);

  getLeadsCriteria(
    searchQuery?: string,
    isActive?: boolean,
    skipLoader?: boolean,
  ): Observable<LeadsCriteria[]> {
    let params = new HttpParams();
    if (searchQuery) {
      params = params.set('name', searchQuery);
    }
    if (isActive !== undefined) {
      params = params.set('is_active', isActive);
    }

    let headers = new HttpHeaders();
    if (skipLoader) {
      headers = headers.set('X-Skip-Loader', 'true');
    }

    return this.http.get<LeadsCriteria[]>(
      `${this.apiBaseUrl}/api/matching-criteria/`,
      { params, headers },
    );
  }

  getLeadCriteriaById(id: string): Observable<LeadsCriteria> {
    return this.http.get<LeadsCriteria>(
      `${this.apiBaseUrl}/api/matching-criteria/${id}`,
    );
  }

  createLeadCriteria(criteria: LeadsCriteria): Observable<LeadsCriteria> {
    return this.http.post<LeadsCriteria>(
      `${this.apiBaseUrl}/api/matching-criteria/`,
      criteria,
    );
  }

  updateLeadCriteria(
    id: string,
    criteria: Partial<LeadsCriteria>,
  ): Observable<LeadsCriteria> {
    return this.http.patch<LeadsCriteria>(
      `${this.apiBaseUrl}/api/matching-criteria/${id}`,
      criteria,
    );
  }

  deleteLeadCriteria(id: string): Observable<void> {
    return this.http.delete<void>(
      `${this.apiBaseUrl}/api/matching-criteria/${id}`,
    );
  }
}
